// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c3ui","footer":"styles_footer__1o3kG"};